export default "__VITE_ASSET__yoOb4tCk__"